module.exports = __webpack_public_path__ + "static/media/6)RECE_1.90933d77.PDF";